<template>
  <div class="resume-container">
    <div class="personal-info-container">
      <div class="photo-container">
        <img class="photo" :src="$DjangoMediaUrl(resumeData.photo)"  @error.once="getDefaultProfilePhoto($event)">
      </div>
      <div class="personal-info">
        <span class="name">{{ resumeData.name }}</span>
        <!-- <p class="personal-statement">{{ resumeData.personal_statement }}</p> -->
        <ExpandCollapse class="personal-statement" :content="resumeData.personal_statement" />
      </div>
    </div>
    <div v-if="aiSummaryInfo" class="info-container ai-summary-info">
      <div class="title">{{ $t('hm.resume.aiSummaryInfo') }}</div>
      <div class="body card-line">{{ aiSummaryInfo }}</div>
    </div>
    <div v-if="aiMatchScore" class="info-container ai-match-info">
      <div class="title">
        <div class="card-title">
          <span class="title">{{ $t('hm.resume.aiResumeMatchInfo') }}</span>
        </div>
        <div class="btn-container">
          <div class="score-container">
            <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="$t('admin.application.candidate.tip.resumeFitInfo')">
              <div ref="aiMatchFitScore" class="chart-score"></div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="body card-line">{{ aiMatchSummary }}</div>
    </div>
    <!-- <div v-if="aiSummaryInfo || aiMatchScore" class="info-container ai-summary-and-match">
      <div class="title">{{ $t('hm.resume.aiSummaryInfo') }}</div>
      <div class="body">
        <div v-if="aiMatchScore" class="line-item">
          <div class="card-title">
            <span class="title">{{ $t('admin.application.candidate.title.aiResumeMatchSummary') }}</span>
            <div class="btn-container">
              <div class="score-container">
                <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="$t('admin.application.candidate.tip.resumeFitInfo')">
                  <div ref="aiMatchFitScore" class="chart-score"></div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="card-line">{{ aiMatchSummary }}</div>
          <el-divider v-if="aiSummaryInfo" class="line"></el-divider>
        </div>
        <div v-if="aiSummaryInfo" class="line-item">
          <div class="card-title">
            <span class="title">{{ $t('admin.application.candidate.title.aiResumeSummaryContent') }}</span>
          </div>
          <div class="card-line">{{ aiSummaryInfo }}</div>
        </div>
      </div>
    </div> -->
    <div class="basic-info-header-container">
      <span class="title">{{ $t('hm.resume.basicInfo') }}</span>
      <div class="download-resume" v-if="resumeData.resume_path">
        <a href="javascript:void(0)" @click="handleDownloadOriginalResume">
          <i class="iconfont icondownload"></i>
          {{ $t('hm.resume.originalResume') }}
        </a>
      </div>
    </div>
    <div class="basic-info-container">
      <div class="apply-for" v-if="resumeData.job">
        <span class='title'>{{ $t('hm.resume.applyFor') }}</span>
        <div class="content">{{ resumeData.job.title }}</div>
      </div>
      <div class="apply-date">
        <span class='title'>{{ $t('hm.resume.jobApplicationDate') }}</span>
        <div class="content">{{ formatTime(resumeData.apply_time) }}</div>
      </div>
      <div class="candidate-name" v-if="resumeData.candidate">
        <span class='title'>{{ $t('hm.resume.legalName') }}</span>
        <div class="content">{{ resumeData.candidate.name }}</div>
      </div>
      <div class="candidate-email">
        <span class='title'>{{ $t('hm.resume.emailAddress') }}</span>
        <div class="content">{{ resumeData.email }}</div>
      </div>
      <div class="candidate-mobile" v-if="resumeData.mobile_id">
        <span class='title'>{{ $t('hm.resume.mobileId') }}</span>
        <div class="content">{{ resumeData.mobile_id }}</div>
      </div>
      <div class="candidate-stlutation" v-if="resumeData.salutation">
        <span class='title'>{{ $t('hm.resume.stlutation') }}</span>
        <div class="content">{{ resumeData.salutation }}</div>
      </div>
      <div class="candidate-birthday" v-if="resumeData.birthday">
        <span class='title'>{{ $t('hm.resume.birthday') }}</span>
        <div class="content">{{ formatTime(resumeData.birthday) }}</div>
      </div>
      <div class="candidate-gender" v-if="resumeData.gender">
        <span class='title'>{{ $t('hm.resume.gender') }}</span>
        <div class="content">{{ resumeData.gender }}</div>
      </div>
      <div class="candidate-location" v-if="resumeData.hukou_location">
        <span class='title'>{{ $t('hm.resume.location') }}</span>
        <div class="content">{{ resumeData.hukou_location }}</div>
      </div>
      <div class="candidate-current-location" v-if="resumeData.current_location">
        <span class='title'>{{ $t('hm.resume.currentLocation') }}</span>
        <div class="content">{{ resumeData.current_location }}</div>
      </div>
      <div class="candidate-address" v-if="resumeData.address1">
        <span class='title'>{{ $t('hm.resume.address') }}</span>
        <div class="content">{{ resumeData.address1 }}</div>
      </div>
      <div class="candidate-address-other" v-if="resumeData.address2">
        <span class='title'>{{ $t('hm.resume.addressOther') }}</span>
        <div class="content">{{ resumeData.address2 }}</div>
      </div>
      <div class="candidate-mobile-phone" v-if="resumeData.mobile">
        <span class='title'>{{ $t('hm.resume.mobilePhone') }}</span>
        <div class="content">{{ resumeData.mobile }}</div>
      </div>
      <div class="candidate-second-phone" v-if="resumeData.second_phone">
        <span class='title'>{{ $t('hm.resume.secondPhone') }}</span>
        <div class="content">{{ resumeData.second_phone }}</div>
      </div>
      <div class="candidate-chat-id" v-if="resumeData.chat_tools && resumeData.chat_tools.length > 0">
        <span class="title">{{ $t('hm.resume.chatId') }}</span>
        <div class="list-container  chat-tools">
          <div
            v-for="(item, index) in resumeData.chat_tools"
            :key="'chat_tools-' + index">
            <span
              class="name"
              >{{ item.tool_name }}</span>
              <span class="value">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="candidate-social-network" v-if="resumeData.social_net_works && resumeData.social_net_works.length > 0">
        <span class="title">{{ $t('hm.resume.socialNetwork') }}</span>
        <div class="list-container social-network">
          <div
            v-for="(item, index) in resumeData.social_net_works"
            :key="'social_net_works-' + index">
            <span
              class="name"
              >{{ item.net_work_name }}</span>
              <span class="value">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="candidate-expected-salary" v-if="resumeData.expected_salary">
        <span class='title'>{{ $t('hm.resume.expectedSalary') }}</span>
        <div class="content">{{ resumeData.expected_salary }}</div>
      </div>

      <div class="referral-info" v-if="resumeData.referral_info && resumeData.referral_info.email">
        <span class='title'>{{ $t('hm.resume.referredBy') }}</span>
        <div class="content">
          <div class="info">
            <div>
              <span class="iconfont iconidentity"></span>
              <span class="text">{{ (resumeData.referral_info.employee && resumeData.referral_info.employee.status) ? $t('hm.resume.employee') : $t('hm.resume.notEmployee') }}</span>
            </div>
            <div v-if="resumeData.referral_info.email">
              <span class="iconfont iconemail"></span>
              <span class="text">{{ resumeData.referral_info.email }}</span>
            </div>
            <div v-if="resumeData.referral_info.name">
              <span class="iconfont iconcandidate"></span>
              <span class="text">{{ resumeData.referral_info.name }}</span>
            </div>
          </div>
          <div class="chain" v-if="resumeData.referral_chain">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="1">
                <template #title>
                  <div v-show="!activeNames.includes('1')">
                    <SimpleReferralChain :referralChainInfo="resumeData.referral_chain" />
                  </div>
                </template>
                <ReferralChain :referralChainInfo="resumeData.referral_chain" />
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
      <div class="referral-resonal" v-if="resumeData.referral_info && resumeData.referral_info.referral_reason">
        <span class="title referral-title">{{ $t('hm.resume.referralReson') }}</span>
        <div class="content">{{ resumeData.referral_info.referral_reason }}</div>
      </div>
    </div>

    <div class="info-container experience" v-if="resumeData.experience && resumeData.experience.length > 0">
      <div class='title'>{{ $t('hm.resume.experience') }}</div>
      <div
        class="body"
        v-for="(item, index) in resumeData.experience"
        :key="'experience-' + index">
        <div class="company" v-if='item.company_name'>
          <span class='title'>{{ $t('hm.resume.workExperience.company') }}</span>
          <span class="content">{{ item.company_name }}</span>
        </div>
        <div class="job-title" v-if='item.job_title'>
          <span class='title'>{{ $t('hm.resume.workExperience.jobTitle') }}</span>
          <span class="content">{{ item.job_title }}</span>
        </div>
        <div class="industry" v-if='item.industry'>
          <span class='title'>{{ $t('hm.resume.workExperience.industry') }}</span>
          <span class="content">{{ item.industry }}</span>
        </div>
        <div class="location" v-if='item.location'>
          <span class='title'>{{ $t('hm.resume.workExperience.locaton') }}</span>
          <span class="content">{{ item.location }}</span>
        </div>
        <div class="date" v-if='item.start_date'>
          <span class='title'>{{ $t('hm.resume.workExperience.date') }}</span>
          <span class="content">{{ formatTimeArea(item.start_date, item.end_date) }}</span>
        </div>
        <div class="salary" v-if='item.salary'>
          <span class='title'>{{ $t('hm.resume.workExperience.salary') }}</span>
          <span class="content">{{ item.salary }}</span>
        </div>
        <div class="description" v-if='item.description'>
          <span class='title'>{{ $t('hm.resume.workExperience.description') }}</span>
          <span class="content">{{ item.description }}</span>
        </div>
      </div>
    </div>

    <div class="info-container intern-experience" v-if="resumeData.intern_experience && resumeData.intern_experience.length > 0">
      <div class='title'>{{ $t('hm.resume.intern') }}</div>
      <div
        class="body"
        v-for="(item, index) in resumeData.intern_experience"
        :key="'intern_experience-' + index">
        <div class="company" v-if='item.company_name'>
          <span class='title'>{{ $t('hm.resume.workExperience.company') }}</span>
          <span class="content">{{ item.company_name }}</span>
        </div>
        <div class="job-title" v-if='item.job_title'>
          <span class='title'>{{ $t('hm.resume.workExperience.jobTitle') }}</span>
          <span class="content">{{ item.job_title }}</span>
        </div>
        <div class="industry" v-if='item.industry'>
          <span class='title'>{{ $t('hm.resume.workExperience.industry') }}</span>
          <span class="content">{{ item.industry }}</span>
        </div>
        <div class="location" v-if='item.location'>
          <span class='title'>{{ $t('hm.resume.workExperience.locaton') }}</span>
          <span class="content">{{ item.location }}</span>
        </div>
        <div class="date" v-if='item.start_date'>
          <span class='title'>{{ $t('hm.resume.workExperience.date') }}</span>
          <span class="content">{{ formatTimeArea(item.start_date, item.end_date) }}</span>
        </div>
        <div class="salary" v-if='item.salary'>
          <span class='title'>{{ $t('hm.resume.workExperience.salary') }}</span>
          <span class="content">{{ item.salary }}</span>
        </div>
        <div class="description" v-if='item.description'>
          <span class='title'>{{ $t('hm.resume.workExperience.description') }}</span>
          <span class="content">{{ item.description }}</span>
        </div>
      </div>
    </div>

    <div class="info-container education" v-if="resumeData.education && resumeData.education.length > 0">
      <div class='title'>{{ $t('hm.resume.education') }}</div>
      <div
        class="body"
        v-for="(item, index) in resumeData.education"
        :key="'education-' + index">
        <div class="school" v-if="item.school_name">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.school') }}</span>
          <span class="content">{{ item.school_name }}</span>
        </div>
        <div class="degree" v-if="item.degree">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.degree') }}</span>
          <span class="content">{{ item.degree }}</span>
        </div>
        <div class="date" v-if="item.start_date">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.date') }}</span>
          <span class="content">{{ formatTimeArea(item.start_date, item.end_date) }}</span>
        </div>
        <div class="gpa" v-if="item.gpa">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.gpa') }}</span>
          <span class="content">{{ item.gpa }}</span>
        </div>
        <div class="academic" v-if="item.academic_rating">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.academic') }}</span>
          <span class="content">{{ formatAcademicRating(item.academic_rating) }}</span>
        </div>
        <div class="summary" v-if="item.summary">
          <span class='title'>{{ $t('hm.resume.educationInfoLabel.summary') }}</span>
          <span class="content">{{ item.summary }}</span>
        </div>
      </div>
    </div>

    <div class="info-container additional-info" v-if="resumeData.additional_info">
      <div class='title'>{{ $t('hm.resume.additionalInfo') }}</div>
      <div class="body">
        <!-- <div class="memberships" v-if="resumeData.additional_info.professional_member">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.memberships') }}</span>
          <span class="content">{{ resumeData.additional_info.professional_member }}</span>
        </div>
        <div class="awards" v-if="resumeData.additional_info.awards">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.awards') }}</span>
          <span class="content">{{ resumeData.additional_info.awards }}</span>
        </div>
        <div class="hobby" v-if="resumeData.additional_info.hobbies">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.hobby') }}</span>
          <span class="content">{{ resumeData.additional_info.hobbies }}</span>
        </div> -->
        <div class="lanaguages" v-if="resumeData.additional_info.languages && resumeData.additional_info.languages.length > 0">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.lanaguages') }}</span>
          <div class="content">
            <div
              v-for="(item, index) in resumeData.additional_info.languages"
              :key="'languages-' + index">
                {{ item }}
            </div>
          </div>
        </div>
        <div class="channel" v-if="resumeData.additional_info.channel">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.channel') }}</span>
          <span class="content">{{ resumeData.additional_info.channel }}</span>
        </div>
        <div class="platform" v-if="resumeData.additional_info.platform">
          <span class='title'>{{ $t('hm.resume.additionInfoLabel.platform') }}</span>
          <span class="content">{{ resumeData.additional_info.platform }}</span>
        </div>
      </div>
    </div>

    <HMRateInfo v-if="showHMRateInfo" :hmRatingInfo="resumeData.hmRatingInfo"/>

    <Questionnaire
      v-if="resumeData.standard_questionnaire && resumeData.standard_questionnaire.length > 0"
      class="questionnaire applicant-questionnaire"
      :questionnaireList="resumeData.standard_questionnaire"
      :questionnaireTitle="$t('hm.resume.applicantQuestionnaire')"
      @videoPop="handelVideoPop"/>

    <Questionnaire
      v-if="resumeData.hr_survey && resumeData.hr_survey.length > 0"
      class="questionnaire hr-questionnaire"
      :questionnaireList="resumeData.hr_survey"
      :questionnaireTitle="$t('hm.resume.hrQuestionnaire')"
      @videoPop="handelVideoPop"/>

    <Questionnaire
      v-if="resumeData.invite_questionnaire && resumeData.invite_questionnaire.length > 0"
      class="questionnaire specific-questions"
      :questionnaireList="resumeData.invite_questionnaire"
      :questionnaireTitle="$t('hm.resume.specificQuestions')"
      @videoPop="handelVideoPop"/>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import ReferralChain from '../../common/components/referralChain.vue'
import Questionnaire from './questionnaire.vue'
import SimpleReferralChain from '../../common/components/simpleReferralChain.vue'
import ExpandCollapse from './expandCollapse.vue'
import HMRateInfo from './hmRatingInfo.vue'
import moment from 'moment'
import { getI18nPropertyValue, isEn } from '@/i18n'
import { generateFitEchartsOption } from '@/constant/application'
import { getJobFitScoreColor, formatJobFitScore } from '@/utils/common'
import { getFileExtension } from '@/utils/oss'
import hmApi from '@/api/hm'

export default {
  components: {
    ReferralChain,
    SimpleReferralChain,
    Questionnaire,
    ExpandCollapse,
    HMRateInfo
  },
  props: {
    resumeData: {
      require: true
    },
    jobId: [String, Number],
    candidateId: [String, Number]
  },
  data () {
    return {
      textSize: {
        minRows: 3,
        maxRows: 5
      },
      statementTextSize: {
        minRows: 3,
        maxRows: 7
      },
      activeNames: []
    }
  },
  computed: {
    showHMRateInfo () {
      const rateList = this.resumeData?.hmRatingInfo?.rate_list
      if (rateList && rateList.length > 0) {
        return true
      }
      return false
    },
    aiSummaryInfo () {
      if (!this.resumeData.ai_summary_info) {
        return ''
      }
      return getI18nPropertyValue(this.resumeData.ai_summary_info, 'ai_summary_cn', 'ai_summary_en')
    },
    aiMatchScore () {
      if (!this.resumeData.ai_match_info) {
        return
      }
      return this.resumeData.ai_match_info.resume_ai_match_score
    },
    aiMatchSummary () {
      if (!this.resumeData.ai_match_info) {
        return ''
      }
      return getI18nPropertyValue(this.resumeData.ai_match_info, 'resume_ai_match_summary_cn', 'resume_ai_match_summary_en')
    }
  },
  created () {
  },
  mounted () {
    this.initFitScore()
  },
  beforeDestroy () {

  },
  methods: {
    async handleDownloadOriginalResume (event) {
      event.preventDefault()
      const extension = getFileExtension(this.resumeData.resume_path)
      const baseName = this.resumeData.name || this.resumeData.candidate?.name || 'resume'
      const fileName = extension ? `${baseName}.${extension}` : baseName
      try {
        const result = await hmApi.getResumeDownloadUrl(this.jobId, this.candidateId, { file_name: fileName })
        window.location.href = result.url
      } catch (error) {
        this.$message.error(this.$t('common.message.downloadFailed'))
      }
    },
    initFitScore () {
      if (!this.aiMatchScore) {
        return
      }
      const el = this.$refs.aiMatchFitScore
      const val = this.aiMatchScore
      const color = getJobFitScoreColor(val)
      const displayValue = formatJobFitScore(val)
      const option = generateFitEchartsOption(val, displayValue, color, 12)
      const series = option.series
      series.axisLine.lineStyle.width = 2
      const chart = echarts.init(el)
      chart.setOption(option)
    },
    handelVideoPop (item) {
      this.$emit('videoPop', item)
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    formatTime (time) {
      if (time) {
        const date = moment(time)
        return date.format('MM/DD/YYYY')
      }
      return ''
    },
    formatWorkTime (startTime, endTime) {
      if (!startTime) {
        return ''
      }
      const startDate = moment(startTime)
      startDate.locale(isEn() ? 'en' : 'zh-cn')
      let endDate = moment(new Date())
      endDate.locale(isEn() ? 'en' : 'zh-cn')
      if (endTime) {
        endDate = moment(endTime)
      }
      const months = endDate.diff(startDate, 'months')
      const month = months % 12
      const year = (months - month) / 12
      let label = ''
      if (year) {
        label += this.$t('hm.resume.workExperience.year', { year: year })
      }
      if (month) {
        label += ' ' + this.$t('hm.resume.workExperience.month', { month: month })
      }
      return startDate.format('MMMM YYYY') + ' - ' + endDate.format('MMMM YYYY') + ` (${label})`
    },
    formatTimeArea (startTime, endTime) {
      if (!startTime) {
        return ''
      }
      const startDate = moment(startTime)
      let endDate = moment(new Date())
      if (endTime) {
        endDate = moment(endTime)
      }
      return startDate.format('MM/YYYY') + ' - ' + endDate.format('MM/YYYY')
    },
    formatAcademicRating (academicRating) {
      if (academicRating === 40 || academicRating === '40') {
        return this.$t('hm.resume.educationInfoLabel.other')
      }
      return `Top ${academicRating}%`
    }
  },
  watch: {
    aiMatchScore: {
      handler () {
        this.$nextTick(() => {
          this.initFitScore()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resume-container {
  margin-top: 10px;

  .personal-info-container {
    display: flex;
    padding: 20px 10px;
    background-color: #FFFFFF;

    .photo-container {
      flex: 1;

      .photo {
        width: 50px;
      }
    }

    .personal-info {
      flex: 6;
      padding: 0 10px;

      .name {
        font-size: 20px;
        font-weight: 600;
        line-height: 1;
      }

      .personal-statement {
        border-top: 1px solid #b4b4b4;
        margin: 10px 0;
        padding: 10px 0;
        white-space: pre-line;
        max-height: 120px;
        overflow: auto;
      }
    }
  }

  .basic-info-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 10px;
    border-bottom: 1px solid #b4b4b4;

    .title {
      font-size: 16px;
      font-weight: 600;
    }

    .download-resume {
      color: #FFFFFF;
      padding: 5px 20px;
      background-color: #0096cc;
      border-radius: 2px;

      > a {
        font-size: 15px;
        color: #FFFFFF;
      }
    }
  }

  .basic-info-container {
    background-color: #FFFFFF;
    margin: 20px 0 0 0;
    padding: 20px 10px ;
    font-size: 14px;

    &> div {
      margin-bottom: 10px;

      &> div {
        padding: 5px 10px;
        background-color: #f7f7f7;
        margin: 5px 0;
      }

      &> span {
        padding: 0 10px;
        color: #b4b4b4;
      }
    }

    .list-container {
      > div {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .referral-info {
      .content {
        padding: 10px;
        .info {
          border-bottom: 0.5px solid #afafaf;
          padding-bottom: 10px;

          &> div {
            display: flex;
            align-items: center;
            padding: 1px 0;
          }

          .iconfont {
            font-size: 30px;
            margin-right: 20px;
            color: #b5b4b4;
          }

          .referral-title {
            margin-right: 20px;
          }
        }
      }
    }

    .referral-resonal {
      .content {
        white-space: break-spaces;
      }
    }
  }

  .info-container {

    >.title {
      padding: 10px 0 5px 10px;
      border-bottom: 1px solid #b4b4b4;
      font-size: 16px;
      font-weight: 600;
    }

    .body {
      padding: 10px;
      margin: 20px 0;
      background-color: #FFFFFF;
      font-size: 14px;

      &> div {
        display: flex;
        flex-direction: column;
        margin-bottom: 5px;
      }

      .title {
        padding: 0 10px;
        color: #b4b4b4;
      }

      .content {
        padding: 5px 10px;
        background-color: #f7f7f7;
        margin: 5px 0;
        white-space: pre-line;
      }
    }
  }

  .ai-summary-info {
    .card-line {
      padding: 10px 20px;
    }
  }

  .ai-match-info {
    .title {
      position: relative;
      .btn-container {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        .score-container {
          position: relative;
          .chart-score {
            display: inline-block;
            vertical-align: top;
            width: 26px;
            height: 26px;
          }
        }
      }
    }
    .card-line {
      padding: 10px 20px;
    }
  }

  .questionnaire {
    padding-bottom: 20px;
  }

  ::v-deep .van-collapse {
    .van-collapse-item__title {
      background-color: unset;
      padding: 10px 16px 10px 5px;
    }

    .van-collapse-item__content {
      padding: 0 0 12px 0;
      background-color: unset;
    }

    &.van-hairline--top-bottom {
      &::after {
        border-width: unset;
        border: 0;
      }
    }

    .van-collapse-item__title {
      padding-bottom: 0;

      &::after {
        border: 0;
      }
    }

  }
}
</style>
